<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4 12.025V13.24C15.4 13.9961 15.4 14.3741 15.2528 14.6629C15.1234 14.9169 14.9169 15.1234 14.6629 15.2529C14.3741 15.4 13.996 15.4 13.24 15.4H6.75998C6.00391 15.4 5.62587 15.4 5.33709 15.2529C5.08307 15.1234 4.87654 14.9169 4.74712 14.6629C4.59998 14.3741 4.59998 13.9961 4.59998 13.24V6.76001C4.59998 6.00394 4.59998 5.62587 4.74712 5.33711C4.87654 5.0831 5.08307 4.87655 5.33709 4.74716C5.62587 4.60001 6.0039 4.60001 6.75998 4.60001H7.97498"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.4 8.65002V4.60002M15.4 4.60002H11.35M15.4 4.60002L9.32495 10.675"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ExternalLinkIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    }
  }
}
</script>
